import { OnInit, OnDestroy, Component, Input } from '@angular/core';
import { EntityrecordApi, EntityfieldApi } from '../../../sdk/index';
import { PlatformApp } from '../../../services/app.service';
import { LoopBackAuth } from '../../../sdk/services/core/auth.service';
import { NotificationsService } from 'angular2-notifications';
import { Observable } from 'rxjs';

@Component({
    selector: 'entityfield-editable',
    templateUrl: 'entityfield-editable.component.html',
    providers: [EntityrecordApi, EntityfieldApi],
    styleUrls: ['entityfield-editable.component.scss']

})

export class EntityFieldEditableComponent implements OnInit, OnDestroy {
    @Input() entityrecordid = '';
    @Input() entityfieldid = '';
    @Input() entityfieldname = '';
    @Input() entityrecord: any = null;
    fieldvalue: any;
    fieldlabel: any;
    fieldtype: string;
    currentuser: any;
    notifyOptions;

    constructor(private _entityfieldApi: EntityfieldApi,
        private _entityrecordApi: EntityrecordApi,
        private _loopBackAuth: LoopBackAuth, private _notificationSrv: NotificationsService) {
        this.notifyOptions = PlatformApp.getNotificationOptions();
    }

    ngOnInit(): void {
        this.currentuser = this._loopBackAuth.getCurrentUserData();
        this._entityfieldApi.findById(this.entityfieldid)
            .map(fieldMeta => { this.fieldtype = fieldMeta['fieldtype']; this.fieldlabel = fieldMeta['label']; })
            .mergeMap(res => this._getFieldValue())
            .subscribe(fieldvalue => this.fieldvalue = fieldvalue);

    }

    private _getFieldValue() {
        if (!this.entityrecord) {
            return this._entityrecordApi.findByIdProcessed(this.entityrecordid).map(data => {
                if (data) {
                    this.entityrecord = data['response'];
                    return this._getFieldValueFromRecord(this.entityrecord);
                } else {
                    return null;
                }
            }, err => { console.error(err); return null; });
        } else {
            return Observable.of(this._getFieldValueFromRecord(this.entityrecord));
        }
    }

    protected onFieldValueChange(event) {
        if (event.target.type === 'checkbox') {
            let newValue = event.target.checked ? true : false;
            this._updateFieldValue(newValue, this.fieldvalue);
        }
    }

    private _updateFieldValue(fieldvalue, oldvalue) {
        let d = { 'data': {} };
        if (this.entityfieldname.indexOf('.') > 0) {
            let keys = this.entityfieldname.split('.').reverse();
            let v = null;
            keys.forEach(k => {
                if (v) {
                    v = { k: v };
                } else {
                    v = { k: fieldvalue };
                }
            });
            d.data = v;
        } else {
            d.data[this.entityfieldname] = fieldvalue;
        }
        this._entityrecordApi.updateattributes(this.entityrecordid, d).subscribe(data => {
            if (data) {
                this.fieldvalue = this._getFieldValueFromRecord(data);
                Object.assign(this.entityrecord, data);
                this._notify('success', 'Updated Successfully', 'Value of field "' + this.fieldlabel + '" is updated');
            } else {
                this.fieldvalue = oldvalue;
                this._notify('error', 'Update Failed', 'Updation of field "' + this.fieldlabel + '" has failed');
            }
        }, err => {
            this.fieldvalue = oldvalue;
            this._notify('error', 'Update Failed', 'Updation of field "' + this.fieldlabel + '" has failed');
        });
    }

    private _getFieldValueFromRecord(record) {
        if (record) {
            if (this.entityfieldname.indexOf('.') > 0) {
                let keys = this.entityfieldname.split('.');
                let tempValue = record.data;
                keys.forEach(k => {
                    if (tempValue) {
                        tempValue = tempValue[k];
                    }
                });
                return tempValue;
            } else {
                return record.data[this.entityfieldname];
            }
        } else { return null; }
    }

    private _notify(type, title?, content?, options?) {
        if (!options) { options = PlatformApp.getNotificationOptions(); }
        if (!options.id) { options.id = type + '-' + title + '_' + content; }
        switch (type) {
            case 'success': this._notificationSrv.success(title, content, options); break;
            case 'alert': this._notificationSrv.alert(title, content, options); break;
            case 'error': this._notificationSrv.error(title, content, options); break;
            case 'info': this._notificationSrv.info(title, content, options); break;
            case 'bare': this._notificationSrv.bare(title, content, options); break;
            default: this._notificationSrv.info(title, content, options);
        }
    }

    ngOnDestroy(): void {
        // code that should be called during destroying of this component
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/widgets/entityfield-editable/entityfield-editable.component.ts